module.exports = __webpack_public_path__ + "static/media/purpose.c8f10743.svg";